import React from 'react';
import { VideoIcon, PhoneIcon } from '../assets/icons/Icons';
import '../styles/hero.css';
import { Link, useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-bento">

          {/* Main Hero Card */}
          <div className="hero-main">
            <div className="hero-orb hero-orb-1" aria-hidden="true"></div>
            <div className="hero-orb hero-orb-2" aria-hidden="true"></div>
            <div className="hero-orb hero-orb-3" aria-hidden="true"></div>

            <div className="hero-badge">
              <span className="hero-badge-pulse" aria-hidden="true"></span>
              <span>Trusted mental healthcare</span>
              <span className="hero-badge-sparkle" aria-hidden="true">✦</span>
            </div>

            <h1>
              Healing Minds
              <br />
              <em>
                Nurturing{' '}
                <span className="hero-italic-wrap">Lives</span>
              </em>
            </h1>
            <p>
              A safe space for healing, growth and compassionate
              mental healthcare — online or in-person
            </p>
            <div className="hero-btns">
              <a
                href="https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary hero-cta"
              >
                <span>Book a session</span>
                <span className="hero-cta-arrow" aria-hidden="true">→</span>
              </a>
              <a href="#services" className="btn-secondary">Explore services</a>
            </div>
          </div>

          {/* Contact Card */}
          <div className="hero-card hero-contact">
            <div className="stat-number">1.5k+</div>
            <div className="stat-label">Patients treated</div>
            <div className="hero-avatars" aria-hidden="true">
              <span className="hero-avatar hero-avatar-1"></span>
              <span className="hero-avatar hero-avatar-2"></span>
              <span className="hero-avatar hero-avatar-3"></span>
              <span className="hero-avatar hero-avatar-more">+</span>
            </div>
            <Link to="/contact" className="hero-contact-btn">
              About Us
              <span className="hero-contact-arrow" aria-hidden="true">→</span>
            </Link>
          </div>

          {/* Video Consult Card */}
          <div
            className="hero-card hero-consult"
            role="button"
            tabIndex={0}
            onClick={() => window.open('https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213', '_blank', 'noopener,noreferrer')}
          >
            <div className="consult-glow" aria-hidden="true"></div>
            <div className="consult-icon">
              <VideoIcon size={22} color="white" />
            </div>
            <h3>Video consult</h3>
            <p>Secure, confidential video consultation wherever you are</p>
            <span className="consult-cta" aria-hidden="true">
              Start now
              <span className="consult-cta-arrow">→</span>
            </span>
          </div>

          {/* Trust Badges */}
          <div className="hero-card hero-trust">
            <h3>Why us</h3>
            <div className="hero-trust-badges">
              <span className="trust-badge">NIMHANS certified</span>
              <span className="trust-badge">Specialist Care</span>
              <span className="trust-badge">Women Led</span>
            </div>
          </div>

          {/* Crisis Helpline */}
          <div className="hero-card hero-crisis">
            <div className="crisis-icon">
              <PhoneIcon size={18} color="white" />
              <span className="crisis-live" aria-hidden="true"></span>
            </div>
            <div>
              <h4>In a mental crisis or feeling overwhelmed?</h4>
              <p>Tele-MANAS <b>1-8008914416</b> <br/> 24×7 Toll Free</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
